import styled from 'styled-components';

export const StyledBulletPoint = styled.li``;

export const StyledBulletPointsList = styled.ol`
    list-style-type: none;
    counter-reset: num;
    & li {
        position: relative;
        display: flex;
        align-items: center;
        height: 60px;
        margin: 0 0 0 0;
        padding: 0 0 0 80px;
        margin-bottom: 20px;
        &:last-child {
            margin-bottom: 0;
            &:after {
                content: none;
            }
        }
        &:before {
            content: counter(num);
            counter-increment: num;
            display: inline-block;
            position: absolute;
            top: 0px;
            left: 0;
            width: 60px;
            height: 60px;
            color: #515151;
            text-align: center;
            line-height: 60px;
            background-color: #d9d9d9;
            border-radius: 50%;
        }
        &:after {
            content: '';
            position: absolute;
            top: 105%;
            left: 30px;
            width: 0px;
            height: 12px;
            border: 1px solid black;
        }
    }
`;
